import Core from './Core';

export default Core;
